// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "", "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontFamily": "\"Nunito Sans\",sans-serif",
	"fontSizeH1": "24px",
	"fontSizeH2": "22px",
	"fontSizeH3": "20px",
	"fontSizeH4": "16px",
	"fontSizeH5": "14px",
	"fontSizeH6": "12px",
	"fontSizeLabel": "10px",
	"lineHeightH1": "16px",
	"lineHeightH2": "16px",
	"lineHeightH3": "16px",
	"lineHeightH4": "16px",
	"lineHeightH5": "16px",
	"lineHeightH6": "16px",
	"lineHeightLabel": "16px",
	"fontWeightRegular": "400",
	"fontWeightSemiBold": "600",
	"fontWeightBold": "700",
	"btnSmallFontSize": "12px",
	"btnMediumFontSize": "14px",
	"btnLargeFontSize": "16px"
};
export default ___CSS_LOADER_EXPORT___;
